module.exports = __webpack_public_path__ + "img/IMG_2783-14344.d1711edc.jpg";